import FilePreview from './file-preview';

export default FilePreview;
